import React, { useEffect, useRef, useState } from "react";
import "./contactUs.style.scss";
import TextField from '@material-ui/core/TextField';
import { Button, Input } from "antd";
import axios from "axios";
import { toast } from "react-toastify";
import { SERVER } from "../../api";
import Loading from "../../loading/loading.index";


export default function ContactUs(props) {

  //const name=useRef();
  const { TextArea } = Input;
  const [name, setName] = useState()
  const [lname, setLName] = useState()
  const [pn, setPN] = useState()
  const [email, setEmail] = useState()
  const [subject, setSubject] = useState()
  const [message, setMessage] = useState()

  const [submitloading, setSubmitLoading] = useState(false);

  function onCLickHandler() {
    setSubmitLoading(true);

    const submit = {
      'firstName': name,
      'lastName': lname,
      'phoneNumber': pn,
      'email': email,
      'subject': subject,
      'message': message
    }

    axios.post(SERVER + "/Support/ContactUs", submit, "accept: text/plain").then(res => {
      setSubmitLoading(false);
      toast.success("پیام شما با موفقیت ارسال شد.");
      setTimeout(
        () => window.location.replace("/page/contact"),
        2000
      );
    });


  }

  return (
    <div className="TMEX-contactus">
      {props.content}
      <br /><br />

      <div className='col'>
        <Input onChange={(e) => setName(e.target.value)} itemRef={name} placeholder='نام' />
        <Input onChange={(e) => setLName(e.target.value)} placeholder='نام خانوادگی' />
        <Input type="email" onChange={(e) => setEmail(e.target.value)} style={{ marginLeft: '0' }} placeholder='ایمیل' />
      </div>
      <div className='col'>
        <Input type="number" onChange={(e) => setPN(e.target.value)} placeholder='تلفن همراه' />
        <Input onChange={(e) => setSubject(e.target.value)} style={{ marginLeft: '0' }} placeholder='عنوان' />
      </div>
      <TextArea onChange={(e) => setMessage(e.target.value)} placeholder="پیام" />
      <div className='contact-btn'>
        <Button onClick={onCLickHandler} loading={submitloading} className="gx-mb-0" type="primary">ارسال پیام</Button>
      </div>

    </div>
  );
}
